import { render, staticRenderFns } from "./BoxContent2.vue?vue&type=template&id=52177dd8&scoped=true"
import script from "./BoxContent2.vue?vue&type=script&lang=js"
export * from "./BoxContent2.vue?vue&type=script&lang=js"
import style0 from "./BoxContent2.vue?vue&type=style&index=0&id=52177dd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52177dd8",
  null
  
)

export default component.exports